import { SVGAttributes } from "react";

const CommunityIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="24"
      height="17"
      viewBox="0 0 24 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="19" cy="6" r="4" fill="#CFB2FF" />
      <circle cx="5" cy="6" r="4" fill="#CFB2FF" />
      <path
        d="M23.723 13.0255C24.0309 14.0863 23.1046 15 22 15C20 15 18 15 16 15C14.8954 15 13.9691 14.0863 14.277 13.0255C14.9574 10.6818 16.815 9 19 9C21.185 9 23.0426 10.6818 23.723 13.0255Z"
        fill="#CFB2FF"
      />
      <path
        d="M9.72295 13.0255C10.0309 14.0863 9.10457 15 8 15C6 15 4 15 2 15C0.89543 15 -0.0308858 14.0863 0.277047 13.0255C0.9574 10.6818 2.81503 9 5 9C7.18497 9 9.0426 10.6818 9.72295 13.0255Z"
        fill="#CFB2FF"
      />
      <circle cx="12" cy="5" r="5" fill="#FFA686" />
      <path
        d="M18.783 15.0156C19.0237 16.0936 18.1046 17 17 17C13.6667 17 10.3333 17 7 17C5.89543 17 4.97629 16.0936 5.21703 15.0156C5.98934 11.5572 8.73336 9 12 9C15.2666 9 18.0107 11.5572 18.783 15.0156Z"
        fill="#FFA686"
      />
    </svg>
  );
};

export default CommunityIcon;
